import { render } from "./BaseChartElement.vue?vue&type=template&id=5b8e4418&scoped=true&ts=true"
import script from "./BaseChartElement.vue?vue&type=script&lang=ts"
export * from "./BaseChartElement.vue?vue&type=script&lang=ts"

import "./BaseChartElement.vue?vue&type=style&index=0&id=5b8e4418&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8e4418"]])

export default __exports__